import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface ManualAccountsReceivableResponse {
  totalAccountReceivable: number;
}

export const getManualAccountsReceivableAPI = async () => {
  const response = await baseAPI.get<ManualAccountsReceivableResponse>(
    '/dashboard/metrics/account-receivable/manual/total',
  );
  return response.data;
};

export const useGetManualAccountsReceivable = (options?: {
  enabled?: boolean;
}) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.MANUAL_ACCOUNTS_RECEIVABLE_TOTAL],
    queryFn: () => getManualAccountsReceivableAPI(),
    enabled: options?.enabled ?? true,
  });
};
